export const CREATE_GRATUITY_RULES_TERMINATION_LIMITED =
  "CREATE_GRATUITY_RULES_TERMINATION_LIMITED";
export const FETCH_GRATUITY_RULES_TERMINATION_LIMITEDS =
  "FETCH_GRATUITY_RULES_TERMINATION_LIMITEDS";
export const FETCH_GRATUITY_RULES_TERMINATION_LIMITED =
  "FETCH_GRATUITY_RULES_TERMINATION_LIMITED";
export const EDIT_GRATUITY_RULES_TERMINATION_LIMITED =
  "EDIT_GRATUITY_RULES_TERMINATION_LIMITED";
export const DELETE_GRATUITY_RULES_TERMINATION_LIMITED =
  "DELETE_GRATUITY_RULES_TERMINATION_LIMITED";
